import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Select, Button } from "@mantine/core";
import { Navigate, useNavigate } from "react-router-dom";

const Correction = () => {
  const Navigate = useNavigate();
  const [selectedReason, setSelectedReason] = useState("");

  const reasons = [
    "My legal name sorted wrong",
    "Missing (Extra) spaces in my legal name",
    "To add my middle name",
    "To separate my first name and last name",
    "Change my legal name to Latin character (my ID has Latin name in it)",
    "Change my legal name to Latin character (my ID does NOT have Latin name)",
    "I got married and want to change my surname",
    "My date of birth is wrongly recognized",
    "I need to modify P2P name",
    "I need to modify App display name (my nickname)",
    "My legal name does not match my bank account's name",
  ];

  return (
    <>
      <Header />
      <div className="flex items-center justify-center bg-gray-50 dark:bg-gray-900 py-10 px-4">
        <div className="max-w-lg w-full p-6 border rounded-xl shadow-sm bg-white dark:bg-gray-800">
          <h2 className="text-2xl font-semibold text-yellow-500 mb-6">
            Personal Information Correction Appeal
          </h2>
          <p className="text-gray-700 dark:text-gray-300 text-sm mb-2">
            Please select the reason
          </p>

          <Select
            placeholder="Select reason"
            data={reasons}
            value={selectedReason}
            onChange={setSelectedReason}
            className="mb-4"
            nothingFound="No options"
            searchable
          />
          <p className="text-xs text-gray-600 dark:text-gray-400 mb-6">
            If you choose the wrong appeal reason, your appeal may fail.
          </p>

          <Button fullWidth size="md" variant="filled" disabled={!selectedReason} color="yellow" onClick={() => Navigate("/personal-informartion-correction")}>
            Submit
          </Button>
        </div>
      </div>
      <Footer />  
    </>
  );
};

export default Correction;
